module.exports = __webpack_public_path__ + "img/nia.0b421ef4.png";